import Vue from 'vue'
import Loading from './loading.vue'

const Mask = Vue.extend(Loading)

const toggleLoading = (el, binding) => {
  if (binding.value) {
    Vue.nextTick(() => {
      if (binding.modifiers.fullscreen) {
        //全屏情况下
        document.body.appendChild(el.mask);
      } else {
        //非全屏情况下
        let height = el.clientHeight; //当前元素高度
        let width = el.clientWidth; //当前元素宽度
        let offsetTop = el.offsetTop; //当前元素距离顶部距离
        //给蒙版赋值
        el.mask.style.top = offsetTop + "px";
        el.mask.style.height = height + "px";
        el.mask.style.width = width + "px";
        el.appendChild(el.mask);
      }
    })
  } else {
    el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask);
    el.instance && el.instance.$destroy();
  }
}

export default {
  bind: function (el, binding) {
    const mask = new Mask({
      el: document.createElement('div'),
      data: {
        fullscreen: !!binding.modifiers.fullscreen,
        background: binding.value.background ? binding.value.background : "rgba(0, 0, 0, .6)",
        color: binding.value.color ? binding.value.color : "#ffffff"
      }
    })
    el.instance = mask
    el.mask = mask.$el
    binding.value && toggleLoading(el, binding)
  },
  update: function (el, binding) {
    if (binding.oldValue !== binding.value) {
      toggleLoading(el, binding)
    }
  },
  unbind: function (el, binding) {
    el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask);
    el.instance && el.instance.$destroy();
  }
}